"use strict";

exports.__esModule = true;
exports["default"] = Facebook;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Facebook(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.1 32V19.7h4.1l.6-4.8h-4.7v-3.1c0-1.4.4-2.3 2.4-2.3H27V5.3c-.4-.1-1.9-.2-3.7-.2-3.7 0-6.2 2.2-6.2 6.3v3.5H13v4.8h4.1V32h5z"
  }));
}